module.exports = __webpack_public_path__ + "img/Clap.0fd90931.svg";